import { parts } from './parts.js';
import { calculateRiskStatus, calculateRiskStatusText, calculateColor, formatDate } from './utilFunctions.js';

// An example of how the data will be passed in via the app
// const exampleAppValues = [
//     {
//         vaultID: '333',
//         stabilityFee: "5.0",
//         debtAmount: "1,165.99",
//         collateralAmount: "1",
//         collateralizationRatio: "134.79",
//         liqRatio: 1.35,
//         safetyRatio: 1.5,
//
//
//     }]

function generateSvg(values) {
    const {
        vaultID,
        stabilityFee,
        debtAmount,
        collateralAmount,
        lastUpdateTime = formatDate(),
        collateralizationRatio,
        liqRatio,
        safetyRatio,
    } = values;

    const riskStatusNumeric = calculateRiskStatus(collateralizationRatio, liqRatio, safetyRatio);
    let riskStatus;

    riskStatus = calculateRiskStatusText(riskStatusNumeric);

    const actualBackgroundGradientColor = calculateColor(riskStatus);

    const chartColor = calculateColor(riskStatus);

    let strokeDashArrayValue = parseFloat(collateralizationRatio);

    const partBeforeRiskText = `x="298" y="350" width="96" height="40" rx="8" fill="#001828" fill-opacity=".7" />
        <circle cx="299" cy="370.5" r="4" />
        <text xml:space="preserve" font-weight="600">
          <tspan x="311" y="374.7">`
    const closedText = `fill="#63676F" xml:space="preserve" font-size="24">
        <tspan x="136" y="210">Zero Balance`

    if ((strokeDashArrayValue <= 100 && strokeDashArrayValue !== 0) || strokeDashArrayValue >= 200) {
        strokeDashArrayValue = 100;
    } else if (strokeDashArrayValue === 0) {
        strokeDashArrayValue = 0;
    } else {
        strokeDashArrayValue = strokeDashArrayValue - 100;
    }

    let finalpartsForApp;
    if (riskStatus === "NO") {
        finalpartsForApp = [
            parts[0],
            vaultID,
            parts[1],
            chartColor,
            parts[2],
            // Risk ratio color
            '#63676F',
            parts[3],
            vaultID,
            parts[4],
            stabilityFee,
            parts[5],
            closedText,
            parts[8],
            lastUpdateTime,
            parts[9],
            strokeDashArrayValue / 100,
            parts[10],
            partBeforeRiskText,
            riskStatus,
            parts[12],
            parts[14],
            // First stop color
            '#4E5356',
            parts[15],
            // Second stop color
            '#001828',
            parts[16],
            parts[17]
        ]
    } else {
        finalpartsForApp = [
            parts[0],
            vaultID,
            parts[1],
            chartColor,
            parts[2],
            actualBackgroundGradientColor,
            parts[3],
            vaultID,
            parts[4],
            stabilityFee,
            parts[5],
            parts[6],
            debtAmount,
            parts[7],
            collateralAmount,
            parts[8],
            lastUpdateTime,
            parts[9],
            strokeDashArrayValue / 100,
            parts[10],
            parts[11],
            riskStatus,
            parts[12],
            parts[13],
            `${collateralizationRatio >= 0 ? `${Math.round(collateralizationRatio)}%` : '∞'}`,
            parts[14],
            actualBackgroundGradientColor,
            parts[15],
            actualBackgroundGradientColor,
            parts[16],
            parts[17]
        ]
    }

    const str = finalpartsForApp;
    return str.join("");
}

export { generateSvg }
